// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const bulkDeleteEntriesQueryParamsSchema = z.object({
  entry_ids: z.coerce.string().describe("Comma-separated list of entry IDs to delete"),
});

export const bulkDeleteEntriesHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Entries deleted
 */
export const bulkDeleteEntries200Schema = z.object({});

/**
 * @description Unauthorized
 */
export const bulkDeleteEntries401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

export const bulkDeleteEntriesMutationResponseSchema = z.lazy(() => bulkDeleteEntries200Schema);
